import {AccountTypes} from "./AccountTypes";

export class FacilityUser {
  name: string;
  email: string;
  initialPassword: string;
  phone: string;
  jobTitle: string;
  accountType: AccountTypes;
  facilityKeys: Array<string>;
  locationKeys: Array<string>;
  $key: string;

  constructor() {
    this.accountType = AccountTypes.manager;
    this.initialPassword = '';
  }
}




// WEBPACK FOOTER //
// ./src/ng2/app/models/facilityUser.ts